// @ts-nocheck
import { FormulaHelpers, Types, FormulaError } from 'fast-formula-parser';

export const _isArray = (value: any) => value.constructor === Array;

export const _isString = (value: any) => value.constructor === String;

const H = FormulaHelpers;
export const convertDataToArrayForMinMax = (arrayValues) => {
  let results = [];

  if (_isArray(arrayValues.value)) {
    try {
      results = H.accept(arrayValues, Types.ARRAY, undefined, true);
    } catch (e) {
      // catch #VALUE! and throw #N/A
      if (e instanceof FormulaError) throw FormulaError.NA;
      throw e;
    }
  } else {
    if (arrayValues.value.constructor === String) {
      throw FormulaError.VALUE;
    }
    results = [arrayValues.value];
  }

  return results;
};

export const getNumValuesFromArray = (valueArray) =>
  valueArray.filter((value) => value?.constructor === Number);
